export const logout = () => {
    localStorage.removeItem("JHU-Etranscript");
    localStorage.removeItem("JHU-order-details");
    window.location.href = "/";
}